import Swiper, { Autoplay, Navigation } from "swiper";
Swiper.use([Autoplay, Navigation]);

jQuery(document).ready(function() {

    jQuery('.header__nav__trigger').click(function() {
      jQuery('.header__menu').toggleClass('d-none');
      jQuery(this).toggleClass('header__nav__trigger--active');

    });

    jQuery('.card__link').hover( 
      function() {
        jQuery(this).parent().find('.card__title--absolute').addClass('card__title--hover');
      }, 
      function() {
        jQuery(this).parent().find('.card__title--absolute').removeClass('card__title--hover');
      },   
    );

    jQuery('[data-tab-link]').click(function(e) {
      e.preventDefault(); 

      jQuery('[data-tab-link]').removeClass('tab--active');
      jQuery(this).addClass('tab--active');
      
      jQuery('[data-tab-content]').addClass('d-none')
      jQuery('[data-tab-content="' + jQuery(this).data('tab-link') + '"]').removeClass('d-none')
    });

    const swiperHero = new Swiper(".swiper-container--hero", {
      direction: "horizontal",
      loop: true,
      slidesPerView: 1,
      centeredSlides: true,
      autoplay: {
        delay: 5000
      },
      spaceBetween: 30,
      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });

    const swiperTestimonial = new Swiper(".swiper-container--testimonials", {
      direction: "horizontal",
      loop: true,
      slidesPerView: 1,
      centeredSlides: true,
      autoplay: {
        delay: 5000
      },
      spaceBetween: 30,
      // Navigation arrows
      navigation: {
        nextEl: ".testimonials__swiper-button-next",
        prevEl: ".testimonials__swiper-button-prev"
      }
    });

    const swiperCategories = new Swiper(".swiper-container--categories", {
      direction: "horizontal",
      loop: false,
      slidesPerView: 1.25,
      centeredSlides: true,
      spaceBetween: 30,
      breakpoints: {
        0: {
          slidesPerView: 1.25,
        },
        768: {
          slidesPerView: 2.5,
        },
      },
    });

    const swiper3col = new Swiper(".swiper-container--3col", {
      direction: "horizontal",
      loop: true,
      slidesPerView: 3,
      centeredSlides: true,
      spaceBetween: 30,
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });

    const config = {
      rootMargin: "0px 0px",
      threshold: 0.0
    };

    const observer = new IntersectionObserver(onIntersection, config);
   
    function onIntersection(entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].intersectionRatio > 0) {
          jQuery(entries[i].target).addClass("in-view");
        } else {
          jQuery(entries[i].target).removeClass("in-view");
        }
      }
    }

    const view = document.querySelectorAll(".view");

    for (let i = 0; i < view.length; i++) {
      observer.observe(view[i]);
    }
    
    jQuery('[data-category-filter]').change(function(e) {
      const current_value = e.target.value;
      filterPosts(current_value);
    });
    
    const url = new URL(window.location.href);

    if (url.searchParams.get('category')) {
      const current_value = url.searchParams.get('category');
      filterPosts(current_value);
    }

    function filterPosts(current_value) {

      const $option = jQuery('[data-category-filter]').find('option[value="' + current_value + '"]');
      const post_type = jQuery('[data-category-filter]').data('post-type');

      let action = 'news_tag';

      if(post_type == 'portfolio') {
       
        action = 'project_tag';

      } 

      const current_text = $option.text();
      $option.prop('selected', true);

      //jQuery('[data-selections]').append('<a class="chip chip--gray mr-2" href="" data-chip-filter="' + current_value + '">' + current_text + '<i class="fa fa-times ml-2"></i></a>');

      jQuery.ajax({
        type       : "GET",
        data       : { val: current_value, action: action },
        dataType   : "html",
        url        : ajax.url,
        beforeSend : function(){
        },
        success    : function(data){
          jQuery('[data-results]').html(data);
        },
        error: function(jqXHR, textStatus, errorThrown) {
          //alert(jqXHR + " :: " + textStatus + " :: " + errorThrown);
        }
      });
      
    }

});